import styled from 'styled-components'

import { ModalBodyContainer } from 'components/modal/styled'

export const ModalBody = styled(ModalBodyContainer)`
  p {
    font-family: ${({ theme }) => theme.fonts.arial};
    font-weight: 400;
  }
  p + p {
    margin-top: ${({ theme }) => theme.spacings[2]};
  }

  form {
    margin-top: ${({ theme }) => theme.spacings[6]};
  }

  button {
    margin-top: ${({ theme }) => theme.spacings[6]};
  }
`
